export default class {
	constructor(obj) {
		this.id = obj.id
		this.selectionId = obj.selection_id
		this.siteId = obj.site_id
	}
}




// WEBPACK FOOTER //
// ./src/dashboard/dto/DtoSelectionSite.js